const empty = (list = false) => (list ? [] : {});
export const dataSearch = (data, config = {}) =>
  data && data.data ? data.data : empty(config.list);
export const pagingSearch = (data) => (data && data.paging ? data.paging : {});
export const isMounted = (data) =>
  data && data.status && data.status === 'success' ? true : false;
